import { bl_fi_budget_line_RowClass } from '../../../dbschema/bl_fi_budget_line.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetLineContainerModel extends BaseContainerModel {
    bl_fi_budget_line: bl_fi_budget_line_RowClass = new bl_fi_budget_line_RowClass();
}
